import React from "react";
import { FaUsers } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "../NewIPDPatientAdmission.module.css";

const GuardianInformation = ({ formData, handleInputChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.section}>
      <h3><FaUsers /> {t("Guardian Information")}</h3>
      <div className={styles.grid3}>
        <div>
          <label>{t("Guardian Name")}</label>
          <input name="guardianName" value={formData.guardianName} onChange={handleInputChange} placeholder={t("Guardian Name")} required />
        </div>
        <div>
          <label>{t("Relation")}</label>
          <select name="guardianRelation" value={formData.guardianRelation} onChange={handleInputChange} required className="themed-select">
            <option value="">{t("Select Relation")}</option>
            <option value="Father">{t("Father")}</option>
            <option value="Mother">{t("Mother")}</option>
            <option value="Spouse">{t("Spouse")}</option>
            <option value="Son">{t("Son")}</option>
            <option value="Daughter">{t("Daughter")}</option>
            <option value="Brother">{t("Brother")}</option>
            <option value="Friend">{t("Friend")}</option>
            <option value="Sister">{t("Sister")}</option>
            <option value="Other">{t("Other")}</option>
          </select>
        </div>
        <div>
          <label>{t("Contact Number")}</label>
          <input name="guardianContactNumber" value={formData.guardianContactNumber} onChange={handleInputChange} placeholder={t("Contact Number")} required />
        </div>
      </div>
    </div>
  );
};

export default GuardianInformation;
